export enum SocialType {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  X = 'x',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube',
  TIKTOK = 'tiktok',
  MASTODON = 'mastodon',
  BLUESKY = 'bluesky',
}